import React, { useContext, useEffect, useState } from 'react'
import { Link, useParams } from 'react-router-dom';
import { GlobalState } from '../../../../GlobalState';
import { TabTitle } from '../../../../util/titleChanger'
import { api } from '../../../../util/urlConfig';
import './staffview.css'

function StaffView() {
    TabTitle("View Staff");
    const { staffId } = useParams();
    const state = useContext(GlobalState);

    const [staffDetail] = state.staffAPI.staffDetail;
    const [users] = state.userAPI.users;
    const [id, setId] = state.staffAPI.id;

    const [values, setValues] = useState({})

    useEffect(() => {
        if (staffId > 0) {
            setId(staffId);
            var today = new Date();
            var dob = new Date(staffDetail.dob);
            var createAt = new Date(staffDetail.created_at);
            var createBy = users.data && staffDetail.created_by ? users.data.find(user => {
                return user.nic === staffDetail.created_by.nic
            }) : ""

            setValues({
                ...values,
                staff_code: staffDetail.staff_code ? staffDetail.staff_code : "",
                first_name: staffDetail.first_name ? staffDetail.first_name : "",
                last_name: staffDetail.last_name ? staffDetail.last_name : "",
                contact_no: staffDetail.contact_no ? staffDetail.contact_no : "",
                dob: staffDetail.dob ? dob.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                nic: staffDetail.nic ? staffDetail.nic : "",
                email: staffDetail.email ? staffDetail.email : "",
                address1: staffDetail.address1 ? staffDetail.address1 : "",
                address2: staffDetail.address2 ? staffDetail.address2 : "",
                address3: staffDetail.address3 ? staffDetail.address3 : "",
                village: staffDetail.village ? staffDetail.village : "",
                city: staffDetail.city ? staffDetail.city : "",
                country: staffDetail.country ? staffDetail.country : "",
                created_at: staffDetail.created_at ? createAt.toLocaleDateString('ja-JP') : today.toLocaleDateString('ja-JP'),
                created_by: staffDetail.created_by ? createBy : { first_name: "", last_name: "" },
                image_url: staffDetail.upload_image ? staffDetail.upload_image.image_url : '/img/dummy_avatar.png'
            })
        }
    }, [id, staffId, staffDetail])

    return (
        <div className="profile-main-container">
            <div className="profile-container">
                <div className="left-container">
                    <img src={api + "/" + values.image_url} alt="avatar" />
                </div>
                <div className='right-container'>
                    <div className="action">
                        <Link to={`/staff-form/${id}`}><i className="uil uil-pen"></i><button></button></Link>
                    </div>
                    <div className="name-title">
                        <h2>{values.first_name + " " + values.last_name}</h2>
                        <p>{values.staff_code}</p>
                    </div>
                    <div className="user-content">
                        <p>DOB : <span>{values.dob}</span></p>
                        <p>Email : <span>{values.email}</span></p>
                        <p className='status'>Created By : <span>{values.created_by ? values.created_by.first_name : ""} {values.created_by ? values.created_by.last_name : ""}</span></p>
                        <p>NIC : <span>{values.nic}</span></p>
                        <p>Contact No : <span>{values.contact_no}</span></p>
                        <p>Created At : <span>{values.created_at}</span></p>
                        <p>Address : <span>{values.address1 + ", " + values.address2 + ", " + values.address3 + ", "}<br />
                            {values.village + ", " + values.city}</span></p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default StaffView